import {
  inject,
  Injectable,
  signal,
  Signal,
  WritableSignal,
} from '@angular/core';
import {
  collection,
  Firestore,
  CollectionReference,
  collectionData,
  query,
  where,
  orderBy,
} from '@angular/fire/firestore';
import { Shoutout, shoutoutConverter } from 'src/app/models/shoutout.model';

@Injectable()
export class ShoutoutsStoreService {
  private _firestore = inject(Firestore);
  private _shoutoutsCollectionRef: CollectionReference<Shoutout>;
  private _shoutouts: WritableSignal<Shoutout[]> = signal<Shoutout[]>([]);
  shoutouts: Signal<Shoutout[] | undefined> = this._shoutouts.asReadonly();

  constructor() {
    this._shoutoutsCollectionRef = collection(
      this._firestore,
      'shoutouts',
    ).withConverter(shoutoutConverter);
  }

  get(
    eventId: string,
    sessionId: string | null = null,
    paid: boolean = true,
    announced: boolean = false,
    moderated: boolean = false,
    approved: boolean = false,
    productId: string | null = null,
    orderByField: string = 'createdAt',
    orderByDirection: 'asc' | 'desc' = 'asc',
  ) {
    if (!eventId) {
      return;
    }

    const whereConditions = [
      where('eventId', '==', eventId),
      where('paid', '==', paid),
      where('announced', '==', announced),
      where('moderated', '==', moderated),
      where('approved', '==', approved),
    ];

    if (sessionId) {
      whereConditions.push(where('sessionId', '==', sessionId));
    }

    if (productId) {
      whereConditions.push(where('productId', '==', productId));
    }

    const q = query(
      this._shoutoutsCollectionRef,
      ...whereConditions,
      orderBy(orderByField, orderByDirection),
    );

    collectionData(q, { idField: 'id' }).subscribe((shoutouts) => {
      this._shoutouts.set(shoutouts);
    });
  }
}
